<template>
  <div class="attachment">
    <div class="form-group">
      <label class="form-control-label">Script:</label>
      <textarea @input="updateScript" :value="currentNode.attachment.script" class="form-control form-control-sm"></textarea>
    </div>
  </div>  
</template>

<script>
import { formBase } from './mixins'

export default {
  mixins: [formBase],
  methods: {
    updateScript() {
      let currentNode = Object.assign({}, this.currentNode)
      currentNode.attachment.script = event.target.value
      this.updateNode(currentNode)
    }
  },
  created() {
    if (_.isEmpty(this.currentNode.attachment)) {
      let updatedNode = Object.assign({}, this.currentNode, {attachment: {script: ''}})
      this.updateNode(updatedNode)
    }
  }
}
</script>
